/**
 * Milestone vertical lines (MapMilestoneLine.vue): a 2px line per milestone from
 * just below its diamond down to the bottom of the scene, coloured by
 * selected / final / default — or by state/status in status view
 * (`isHidingMilestoneColors`, unless selected).
 */
import { cssVar, hexagonStatusFill, modeOf } from '../../draw/palette';
import { milestoneDim } from './MilestoneMarkersPainter';
import type { SceneContext } from '../../engine/SceneContext';

export function drawMilestoneLines(
  ctx: CanvasRenderingContext2D,
  scene: SceneContext,
): void {
  const { map, io } = scene;
  ctx.lineWidth = 2;
  for (const ms of io.milestones) {
    if (ms.isHiddenOnMap || map.isHiddenMirroredMilestone(ms.id)) {
      continue;
    }
    const x = scene.screenX(map.milestonePos(ms)) + 0.5;
    if (x < -10 || x > scene.width + 10) {
      continue;
    }
    const selected =
      map.selectedContext === 'milestone' && map.selectedId === ms.id;
    ctx.strokeStyle = selected
      ? cssVar('--color-bluelight-500', '#0BA5EC')
      : map.isHidingMilestoneColors
        ? hexagonStatusFill(modeOf(ms.state, ms.status))
        : ms.isFinal
          ? cssVar('--color-gray-800', '#1D2939')
          : cssVar('--color-gray-400', '#98A2B3');
    ctx.globalAlpha = milestoneDim(scene, ms.id, !!ms.mirrored);
    const y1 = ms.mirrored ? 160 : 130;
    ctx.beginPath();
    ctx.moveTo(x, y1);
    ctx.lineTo(x, scene.height);
    ctx.stroke();
  }
  ctx.globalAlpha = 1;
}
